<div *ngIf="loading">
    <app-loading></app-loading>
</div>
<div *ngIf="loadingTransaction && !loading" class="d-flex justify-content-center">
    <app-small-loading></app-small-loading>
</div>

<div *ngIf="!loading && !loadingTransaction" class="container-fluid ml-2 mt-4">

    <section id="asset-info">
        
        <!-- Back button -->
        <div class="back">
            <button class="btn back-arrow" (click)="goBack()"><img src="../../assets/img/icons/chevron-left.svg" alt="back arrow"></button>
            <span class="ml-1">{{ 'Go back' | translate }}</span>
        </div>

        <!-- Asset's info -->
        <div class="d-flex flex-row flex-wrap mt-2 ml-4">
            <div class="icon">
                <img [src]="asset.icon_url" alt="Asset icon">
            </div>

            <div class="info">
                <h1> {{ this.asset.name }}</h1>
                
                <div class="seller">
                    <span>{{ 'Seller' | translate }}</span>
                    <span style="font-weight: 600"> {{ 'Username' }}</span>
                </div>

                <div class="chain">
                    <span>{{ 'Chain' | translate }}</span>
                    <span style="font-weight: 600"> {{ asset.network.name }}</span>
                </div>
                
                <div class="parts">
                    <span>{{ 'Available' | translate }}</span>
                    <span style="font-weight: 600"> {{ asset.available_percent }}%</span>
                </div>

                <div class="price">
                    <span>{{ 'Price' | translate }}</span>
                    <span style="font-weight: 600"> {{ asset.price }} {{ asset.network.currency_symbol }}</span>
                </div>

                <div class="revenue">
                    <span>{{ '1 year expected revenue' | translate }}</span>
                    <span style="font-weight: 600"> 1.23%</span>
                </div>

                <div class="roi">
                    <span>{{ 'Return of investment (ROI)' | translate}}</span>
                    <span style="font-weight: 600"> {{ asset.roi }} {{ asset.network.currency_symbol }}</span>
                </div>

                <!-- <div class="status-available" *ngIf="asset.status === 'available'">{{ 'Available for purchase' | translate}}</div> -->
                <div class="status-sold" *ngIf="asset.status === 'sold'">{{ 'SOLD' | translate }}</div>

                <div class="options">
                    <button (click)="openBuyModal()" *ngIf="!isUserOwner && asset.available_percent > 0 && asset.saleInfo" class="btn">{{ 'Buy' | translate}}</button>
                    <button (click)="openSellModal()" *ngIf="isUserOwner && asset.available_percent > 0 && !asset.saleInfo" class="btn">{{ 'Sell' | translate}}</button>
                    <button (click)="openSellModal()" *ngIf="isUserOwner && asset.available_percent > 0 && asset.saleInfo" class="btn">{{ 'Update sale' | translate}}</button>
                    <button *ngIf="pool.address" class="btn dist-pool" (click)="goToPool()">{{ 'See distribution pool' | translate }}</button>
                </div>

            </div>
        </div>
    </section>

    <!-- Collection's info and price history -->
    <section id="extra-info">
        
        <!-- Collection's info -->
        <div class="creator">

            <div class="title">
                <p style="font-weight: 600; font-size: 20px">{{'About de collection creator' | translate}}</p>
            </div>

            <div class="collection-creator-info">
                <p style="color: #6C6777"> {{ 'Short description' }}</p>
                <div>
                    <span style="font-weight: 600">{{ 'Contact info:' | translate}} </span>
                    <span> {{ 'creator@contact.com' }} </span>
                </div>
                <div>
                    <span style="font-weight: 600">{{ 'Number of collections:' | translate }} </span>
                    <span> {{ 9 }}</span>
                </div>
                <!-- <div class="mb-4">
                    <span style="font-weight: 600">{{ 'Ranking/Reputation: ' | translate }}</span>
                    <span>4.5</span>
                </div> -->
            </div>

        </div>

        <!-- Price history -->
        <div class="price-chart">
            <span style="color: #5A5564; font-size: 20px">{{'Price history' | translate }}</span>
            <app-line-chart [data]="chartData"></app-line-chart>
        </div>
        <div class="d-flex flex-column">
            <span style="font-weight: 600; font-size: 20px">{{ 'Collection documentation' | translate }}</span>
            <div class="contract">
                <span style="font-weight: 500"><a [href]="asset.term_conditions_url" rel="noopener noreferrer" target="_blank"> {{ asset.term_conditions_url }} </a></span>
                <span><a [href]="asset.term_conditions_url"><img src="../../assets/img/icons/global.svg" alt="web icon" class="web-icon"></a></span>
            </div>
        </div>
    </section>

    <!-- Transactions -->
    <!-- <mat-select placeholder="Filter" [(value)]="selectedFilter" (selectionChange)="onChangeFilter()">
        <mat-option *ngFor="let filter of availableFilters" [value]="filter" >{{ filter }}</mat-option>
    </mat-select>
    <div class="selected-filters" >
        <div class="filter" *ngFor="let filter of selectedFilters">{{ filter | translate }} <img src="../../assets/img/icons/close.svg" height="15" alt="close icon" (click)="deleteFilter( filter )"></div>
    </div> -->
    <!-- <section id="last-transactions">
        <span style="font-weight: 500; font-size: 24px">{{ 'Last transactions' | translate }}</span>

        <div class="table-responsive">
            <app-no-results-found *ngIf="asset.purchasesHistory.length === 0" [text]="'No transactions found'"></app-no-results-found>
            <table *ngIf="asset.purchasesHistory.length > 0" class="transactions-table">
                <thead>
                    <tr>
                        <th>{{ 'User' | translate}}</th>
                        <th>{{ 'Price' | translate}}</th>
                        <th>{{ 'Date' | translate}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let trans of asset.purchasesHistory">
                        <td>{{ trans.buy_user_id }}</td>
                        <td>{{ trans.price }}</td>
                        <td>{{ trans.date_buy | date }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

    </section> -->
</div>